<template>
<v-autocomplete
  v-model="storeParty"
  :items="userStoreParties"
  background-color="input"
  class="ma-0"
  dense
  item-text="party_name"
  item-id="party_id"
  label="Store Group / Store"
  :menu-props="{ maxHeight: 300 }"
  outlined
  return-object
  hide-details
  @change="updateStoreGroup">
</v-autocomplete>
</template>

<script>
import { userAccess } from '@/mixins/user-access'
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'StorePartiesDropdown',
  props: {
    userStoreParties: Array
  },
  mixins: [userAccess, displayAlert],
  data() {
    return {
      storeParty: {}
    }
  },
  async created() {
    if (this.userStoreParties) {
      this.storeParty = sessionStorage.tpr_pro_store_group ? JSON.parse(sessionStorage.tpr_pro_store_group) : this.userStoreParties.find(p => p.party_id)
      this.$emit('updateStoreParty', this.storeParty)
    }
  },
  methods: {
    updateStoreGroup() {
      sessionStorage.setItem('tpr_pro_store_group', JSON.stringify(this.storeParty))
      this.$emit('updateStoreParty', this.storeParty)
    }
  }
}
</script>
<style>
div.v-subheader.theme--light {
  font-weight: bold !important;
  color: black !important;
  font-size: medium !important;
}
</style>